import { THEME_DRAWER_WIDTH } from '@config/theme';
import { shouldForwardProp, shouldNotForwardProps } from '@helpers/misc';
import { AppBar, Box, SxProps } from '@mui/material';
import { styled } from '@mui/material/styles';

import { AppBarStyledProps, MainStyleProps } from './types';

export const MainLayoutStyled = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
});

export const AppBarStyled = styled(AppBar, {
  shouldForwardProp: (prop) =>
    shouldForwardProp<AppBarStyledProps>(['drawerOpened'], prop),
})<AppBarStyledProps>(({ theme, drawerOpened }) => ({
  backgroundColor: theme.palette.background.default,
  transition: drawerOpened ? theme.transitions.create('width') : 'none',
}));

export const MainContentStyled = styled('main', {
  shouldForwardProp: shouldNotForwardProps(['open', 'theme']),
})((x: MainStyleProps) => ({
  ...x.theme.typography.mainContent,
  ...(!x.open && {
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    transition: x.theme.transitions.create('margin', {
      easing: x.theme.transitions.easing.sharp,
      duration: x.theme.transitions.duration.leavingScreen,
    }),
    [x.theme.breakpoints.up('md')]: {
      marginLeft: -(THEME_DRAWER_WIDTH - 20),
      minWidth: `calc(100% - ${THEME_DRAWER_WIDTH}px)`,
    },
    [x.theme.breakpoints.down('md')]: {
      marginLeft: '20px',
      minWidth: `calc(100% - ${THEME_DRAWER_WIDTH}px)`,
    },
    [x.theme.breakpoints.down('sm')]: {
      marginLeft: '10px',
      minWidth: `calc(100% - ${THEME_DRAWER_WIDTH}px)`,
      marginRight: '10px',
      padding: '10px',
    },
  }),
  ...(x.open && {
    transition: x.theme.transitions.create('margin', {
      easing: x.theme.transitions.easing.easeOut,
      duration: x.theme.transitions.duration.enteringScreen,
    }),
    marginLeft: 0,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    minWidth: `calc(100% - ${THEME_DRAWER_WIDTH}px)`,
    [x.theme.breakpoints.down('md')]: {
      marginLeft: '20px',
    },
    [x.theme.breakpoints.down('sm')]: {
      marginLeft: '10px',
      marginRight: '10px',
      padding: '10px',
    },
  }),
  marginTop: 0,
}));

export const mainLayoutToolbarSX: SxProps = {
  '&.MuiToolbar-gutters': {
    xs: { paddingLeft: '10px', paddingRight: '10px' },
    sm: { paddingLeft: '20px', paddingRight: '20px' },
  },
};
